export default "__VITE_ASSET__9eab840a__"